<template lang="pug">
    v-dialog(v-model="value" scrollable max-width=640 @click:outside="$emit('input', false)")
        v-card 
            v-card-title.mb-4.text-center {{title}}
            v-card-text
                .share-message {{message}}
                .share-link
                    v-text-field(v-model="link" solo dense outlined readonly hide-details ref="linkToCopy")
                .share-btn
                    v-btn(:href="link" text color="primary" target="_blank") 
                        v-icon(left) visibility
                        | {{$t('EstimatesAndInvoices.__PreviewInNewWindow')}}

            v-card-actions.justify-center.mb-6
                v-btn.mr-6(v-if="cancelText != ''" rounded dark @click="copyAction()" color="lightGray" min-width='112') {{cancelText}}
                v-btn(rounded dark @click="markAction" color="primary" min-width='112') {{confirmText}}
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    message: {
      type: String,
      default: ""
    },
    confirmText: {
      type: String,
      default: ""
    },
    cancelText: {
      type: String,
      default: ""
    },
    link: {
      type: String,
      default: ""
    },
    confirmAction: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    copyAction() {
      this.$emit("input", false)
      this.$store.dispatch("global/showAlertSuccess", this.$t("Messages.__CopyToClipboard"))
      let textToCopy = this.$refs.linkToCopy.$el.querySelector("input")
      textToCopy.select()
      document.execCommand("copy")
    },
    markAction() {
      this.copyAction()
      this.confirmAction()
    }
  }
}
</script>
